import axios from "axios";
import { useState, useEffect } from "react";
import Paginacion from "../../components/paginador/paginacion";
import { propsColeccion } from "../../models/Colecciones.model";
import { webApiContenidoSeccionTotal } from "../../routes/endpoints";
import Titulo from "./titulo";
import Contenido from "./contenido";

export default function Principal(props: propsColeccion){
    const [totalDePaginas, setTotalDePaginas] = useState(0);
    const [pagina, setPagina] = useState(1)
    const [orden, setOrden] = useState(2)       
    let registrosPorPagina = 8           
    useEffect(()=>{
        axios.post(webApiContenidoSeccionTotal, {id: props.id, seccion:props.seccion} ).then((response) => {             
            setTotalDePaginas(Math.ceil(((response.data)[0].total_registros)/registrosPorPagina));                
        }).catch(err => console.warn(err));        
    },[]);  
     
    return(
        <> 
            <Titulo onChange={nuevoOrden=> ( setOrden(nuevoOrden), setPagina(1) )} seccion={props.seccion}/>
            <div className="container-fluid">
                <Contenido id={props.id} pagina={pagina} registrosPorPagina={registrosPorPagina} orden={orden} seccion={props.seccion} key={1}/>
            </div>
            <Paginacion cantidadTotalDePaginas={totalDePaginas} paginaActual={pagina} onChange={nuevaPagina=>setPagina(nuevaPagina)} registrosPorPagina={registrosPorPagina} />
           
        </>
    );
}